import React from 'react';
import Highlight from '@components/common/Highlight';
import { Tooltip } from 'antd';
import { useAtomValue } from 'jotai';
import { searchTextAtom } from '../../atoms';
import { Link } from 'react-router-dom';

const RootCauseTitle = ({ record }) => {
  const {
    alertId,
    alertType,
    areAllRCDimensionsAvailable,
    isDeletedMetric,
    rootCauseDisplay = '',
  } = record;
  const searchText = useAtomValue(searchTextAtom);
  const urlPrefix = window.conviva?.baseUrl;
  const alertPath = (() => {
    if (alertType === 'AD_ALERT') {
      return 'pre-ad-diagnostics';
    }
    if (alertType === 'APP_ALERT') {
      return 'pre-app-diagnostics';
    }
    return 'pre-diagnostics';
  })();

  const rootCause = rootCauseDisplay?.split(' and ').map((part, index, array) => {
    // If it's not the last part, append <br /> after each part.
    return index < array.length - 1 ? (
      <>
        <b key={part}>
          <Highlight text={`${part} and`} highlight={searchText} />
        </b>
        <br />
      </>
    ) : (
      <b key={part}>
        <Highlight text={part} highlight={searchText} />
      </b>
    );
  });

  if (!areAllRCDimensionsAvailable) {
    return (
      <Tooltip
        key={rootCauseDisplay}
        title="Diagnostics are currently not supported for root-cause based on Custom Dimensions."
      >
        {rootCause}
      </Tooltip>
    );
  }

  if (isDeletedMetric) {
    return (
      <Tooltip key={rootCauseDisplay} title="The metrics has been deleted.">
        {rootCause}
      </Tooltip>
    );
  }

  const openInNewTab = (e) => {
    e.preventDefault();
    window.open(
      `${urlPrefix}/dashboard/ai-alerts/${alertPath}/${alertId}/`,
      '_blank',
      'noopener,noreferrer',
    ); // Open route in a new tab
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <Link
        style={{ color: '#1556FF', fontWeight: 500 }}
        to={`${urlPrefix}/dashboard/ai-alerts/${alertPath}/${alertId}/`}
        onClick={openInNewTab}
      >
        {rootCause}
      </Link>
    </div>
  );
};

export default RootCauseTitle;
